import PropTypes from 'prop-types';
import React from 'react';
import { CSSTransition } from 'react-transition-group';

import AnimationAccordion from './Accordion';
import AnimationBreadcrumbs from './Breadcrumbs';
import AnimationDropdown from './Dropdown';
import AnimationModal from './Modal';
import AnimationSlide from './Slide';

const AnimationEnum = {
  accordion: AnimationAccordion,
  breadcrumbs: AnimationBreadcrumbs,
  dropdown: AnimationDropdown,
  modal: AnimationModal,
  slide: AnimationSlide,
};

const Animation = React.forwardRef(({ name, children, ...rest }, ref) => {
  // Animating height is tricky, handle it separately
  if (name === 'accordion') {
    return <AnimationAccordion {...rest}>{children}</AnimationAccordion>;
  }

  const AnimationComponent = AnimationEnum[name];
  return (
    <CSSTransition
      appear
      classNames={name}
      transitionName={name}
      unmountOnExit
      {...rest}
    >
      <AnimationComponent ref={ref}>{children}</AnimationComponent>
    </CSSTransition>
  );
});

Animation.propTypes = {
  children: PropTypes.node,
  name: PropTypes.oneOf(Object.keys(AnimationEnum)),
};

const defaultTimeout = {
  enter: 0,
  exit: 500,
};

Animation.defaultProps = {
  timeout: defaultTimeout,
};

export default Animation;
